<template>
    <div class="true-false-switch">
        <template v-if="busy">
            <b-spinner label="waiting indicator" small type="grow"></b-spinner>
        </template>
        <template v-else-if="plain">
            <div class="true switch" @click="trueAction">
                <font-awesome-icon icon="check" />
            </div>
            <div class="false switch" @click="falseAction">
                <font-awesome-icon icon="times" />
            </div>
        </template>
        <template v-else>
            <div
                :class="state ? 'text-success': 'text-secondary'"
                class="true switch"
                @click="trueAction"
            >
                <font-awesome-icon icon="check" />
            </div>
            <div
                :class="(!state && state !== null) ? 'text-danger' : 'text-secondary'"
                class="false switch"
                @click="falseAction"
            >
                <font-awesome-icon icon="times" />
            </div>
        </template>
    </div>
</template>

<script>
import "./TrueFalseSwitch.scss";

export default {
    name: "TrueFalseSwitch",
    props: ["plain", "state", "busy"],
    methods: {
        trueAction() {
            this.$emit("true");
        },
        falseAction() {
            this.$emit("false");
        }
    }
};
</script>